/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ridge_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jan,Feb,Mar
12,15,19
13,16,20
11,14,18`)
};

const es_ridge_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ene,Feb,Mar
12,15,19
13,16,20
11,14,18`)
};

const de_ridge_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jan,Feb,Mär
12,15,19
13,16,20
11,14,18`)
};

const nl_ridge_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jan,Feb,Mrt
12,15,19
13,16,20
11,14,18`)
};

const fr_ridge_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jan,Fév,Mar
12,15,19
13,16,20
11,14,18`)
};

const it_ridge_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gen,Feb,Mar
12,15,19
13,16,20
11,14,18`)
};

const pt_br2_ridge_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jan,Fev,Mar
12,15,19
13,16,20
11,14,18`)
};

const pt_ridge_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jan,Fev,Mar
12,15,19
13,16,20
11,14,18`)
};

const ja_ridge_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jan,Feb,Mar
12,15,19
13,16,20
11,14,18`)
};

const zh_ridge_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一月,二月,三月
12,15,19
13,16,20
11,14,18`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ridge_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ridge_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ridge_placeholder", locale)
	if (locale === "en") return en_ridge_placeholder(inputs)
	if (locale === "es") return es_ridge_placeholder(inputs)
	if (locale === "de") return de_ridge_placeholder(inputs)
	if (locale === "nl") return nl_ridge_placeholder(inputs)
	if (locale === "fr") return fr_ridge_placeholder(inputs)
	if (locale === "it") return it_ridge_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_ridge_placeholder(inputs)
	if (locale === "pt") return pt_ridge_placeholder(inputs)
	if (locale === "ja") return ja_ridge_placeholder(inputs)
	return zh_ridge_placeholder(inputs)
};